module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_section_new.d091c.png";